import React, { Dispatch } from 'react';
import Translator from '../../core/i18n';
import { Log } from 'ng2-logger';
import { IAnnouncementsProps } from '../../models/components/announcement';
import { Common } from '../../core/common';
import { IAppState, IAction } from '../../models/action/core';
import { connect } from 'react-redux';
import * as Actions from '../../store/actions/coursePage';
import Moment from 'moment';
import Loading from '../loading/loading';
import { SecureImage } from '../core/secureImage';
import * as AnnouncementActions from '../../store/actions/announcement';
import { Redirect } from 'react-router-dom';
import { TabMenuItems } from '../../models/components/lesson-menu-tab';
import { Guid } from 'guid-typescript';
import ContentLoader from 'react-content-loader';
import ReactGA from 'react-ga4';

// tslint:disable-next-line:no-var-requires
const MomentTr = require('moment/locale/tr');
// tslint:disable-next-line:no-var-requires
const MomentEn = require('moment/locale/en-gb');
const MomentAr = require('moment/locale/ar');

const T = Translator.create();
const _logger = Log.create('announcements.tsx');
const token: any = localStorage.getItem('access_token');
let _common: Common;

export class Announcements extends React.Component<IAnnouncementsProps> {
    state = {
        redirect: false,
        redirectUrl: '/'
    };

    constructor(props: any) {
        super(props);
        this.state = {
            redirect: false,
            redirectUrl: '',
        };

        _common = new Common();
        if (T.i18next.language === 'tr') {
            Moment.locale('tr');
        }
        if (T.i18next.language === 'en') {
            Moment.locale('en');
        }
    }

    onClick = (event: any) => {
        this.setState({ redirect: true, redirectUrl: event.currentTarget!.getAttribute('data-redirectLink') });
    };

    public componentDidMount = () => {
        if (this.props.coursePageClassId) {
            this.props.dispatch(
                Actions.getCoursePageAnnouncementsAction(
                    this.props.coursePageClassId,
                    this.props.coursePageActivityId!,
                    'getCoursePageAnnouncementsAction',
                    'get'
                )
            );
        }
    };

    public onAnnouncementClick(announcementId: string, index: number) {
        ReactGA.event({
            category: window.location.host,
            action: 'G_ACCOUNCEMENT_CLICKED',
            label: 'G_ACCOUNCEMENT_CLICKED',
            nonInteraction: true,
        });
        this.props.dispatch(AnnouncementActions.GetLoginAnnouncementById(announcementId, 'getLoginAnnouncement', 'get', index));
        this.props.triggerAnnouncementModal();
    }


    public render() {
        const loadingSpaces = 74;
        const { redirect, redirectUrl } = this.state;

        if (redirect) {
            const redirectTo = `${window.appSettings.DEFAULT_URL}/${redirectUrl}`;
            return <Redirect push={true} to={redirectTo} />;
        }

        function truncateText(text: string | undefined, maxLength: number): string {
            if (!text) return '';
            return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
        }

        return (
            <div className="announcements white-box p-3" style={{ minHeight: '150px', paddingTop: "10px" }}>
                <a
                    data-redirectLink={
                        'u/course?classId=' +
                        this.props.coursePageClassId +
                        '&activityId=' +
                        this.props.coursePageActivityId +
                        '&type=' +
                        TabMenuItems.announcements
                    }
                    onClick={this.onClick}
                >
                    <span className='lms-header-medium' tabIndex={0}>
                        {T.t('r_menu_announcements')}
                        <span className="count" style={{marginInlineStart: "0.5rem"}} tabIndex={0}>
                            {this.props.announcements?.length ?? 0}
                        </span>
                    </span>
                </a>
                <Loading spinnerId={'getCoursePageAnnouncementsAction'}>
                    <div style={{ backgroundColor: '#eeede9' }}>
                        <ContentLoader
                            speed={2}
                            backgroundColor="#f3f3f3"
                            foregroundColor="#ecebeb"
                            viewBox="0 0 350 200"
                            style={{ width: '100%' }}
                        >
                            <circle cx="36" cy="64" r="30" />
                            <rect x="85" y="42" rx="0" ry="0" width="200" height="15" />
                            <rect x="85" y="68" rx="0" ry="0" width="200" height="15" />

                            <circle cx="36" cy={loadingSpaces + 64} r="30" />
                            <rect x="85" y={loadingSpaces + 42} rx="0" ry="0" width="200" height="15" />
                            <rect x="85" y={loadingSpaces + 68} rx="0" ry="0" width="200" height="15" />

                        </ContentLoader>
                    </div>
                </Loading>
                <div className=' py-3 px-2 ' id="getCoursePageAnnouncementsAction_Content">{this.props.announcements?.length ?(
                    <div >
                        {this.props.announcements!.slice(0, 3).map((announcement, index) => (

                            <div
                                key={Guid.create().toString()}
                                className="points d-flex"
                                onClick={this.onAnnouncementClick.bind(this, announcement.announcementId!, index)}
                            >
                                <SecureImage
                                    style={{ borderRadius: 100 }}
                                    width={42}
                                    height={42}
                                    class={'userProfile mr-1'}
                                    imageUrl={announcement.fromAvatarPath!}
                                />
                                <div className="ml-0">
                                    <h6 tabIndex={0}>{announcement.subject ?? T.t('r_default_empty_content')}</h6>

                                    <span tabIndex={0} dangerouslySetInnerHTML={{ __html: truncateText(announcement.body || T.t('r_default_empty_content'), 117) }} />


                                    <small className="date" tabIndex={0}>{Moment(announcement.createdDate).fromNow()}</small>
                                </div>
                                {!announcement.isRead && <div className='notify-dot' />}

                            </div>
                        ))}
                    </div>
                ) :
                this.props.coursePageActivityId && T.t('r_announcement_not_found')

                }</div>



            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IAnnouncementsProps): IAnnouncementsProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: IAnnouncementsProps = Object.assign({}, ownProps, {
        announcements: state.coursePage.announcements,
        coursePageClassId: state.coursePage.coursePageClassId,
        coursePageActivityId: state.coursePage.coursePageActivityId,
        announcementIsLoaded: state.coursePage.announcementIsLoaded
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret =
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId &&
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.coursePage.announcements === prev.coursePage.announcements;
    return ret;
};

const CAnnouncements = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(Announcements);

export default CAnnouncements;
